import { CurrencyPipe, DecimalPipe, NgIf, NgOptimizedImage, TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Listing } from 'src/app/api';
import { AppComponent } from 'src/app/app.component';
import { CurrencyITFormatPipe } from 'src/app/pipes/currency-itformat.pipe';
import { BadgeComponent } from '../badge/badge.component';

@Component({
  selector: 'app-card-search-annunci-recenti',
  templateUrl: './card-search-annunci-recenti.component.html',
  styleUrls: ['./card-search-annunci-recenti.component.scss'],
  standalone: true,
  imports: [NgIf, BadgeComponent, DecimalPipe, TitleCasePipe, CurrencyPipe, CurrencyITFormatPipe, RouterLink, NgOptimizedImage]
})
export class CardRicercheRecentiComponent implements OnInit {
  @Input() isHome: boolean;
  @Input() showPrice: boolean;
  @Input() annuncioObj: Listing;
  @Input() indexImageAnnuncio: number;
  @Input() isPrint: boolean;
  imgIndex = 0;
  public publicImages = [];

  constructor(public main: AppComponent) { }

  ngOnInit(): void {
    this.publicImages = this.annuncioObj?.images?.filter((item) => item?.website);
  }

  imageAnnuncio(): string {
    try {
      return this.publicImages &&
        this.publicImages[this.imgIndex].url
        ? this.publicImages[this.imgIndex].url
        : 'assets/img/placeholders/annuncio.jpg';
    } catch (error) {
      return 'assets/img/placeholders/annuncio.jpg';
    }
  }

  incrementImgCount(len): void {
    if (this.imgIndex === len) {
      this.imgIndex = 0;
    } else {
      this.imgIndex++;
    }
  }

  decrementImgCount(len): void {
    if (this.imgIndex === 0) {
      this.imgIndex = len;
    } else {
      this.imgIndex--;
    }
  }

  generateurl(): string {
    return `/${this.main.generateRouteByContractAndStatus(this.annuncioObj)}/${this.annuncioObj?.slug}`;
  }

  showMandateType(): boolean {
    const from = new Date(new Date(this.annuncioObj.mandate_from).setDate(new Date(this.annuncioObj.mandate_from).getDate() - 1));
    const to = new Date(new Date(this.annuncioObj.mandate_to).setDate(new Date(this.annuncioObj.mandate_to).getDate() + 1));
    const today = new Date();
    return from <= today && today <= to;
  }
}
